// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`
}

const ROOTS_AUTH = '/auth'
const ROOTS_DASHBOARD = '/libra'
const ROOTS_SAMPLE = '/sample'

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
}

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  research: '/research',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
}

export const PATH_SAMPLE = {
  sample: '/sample',
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    files: path(ROOTS_DASHBOARD, '/files'),
    home: path(ROOTS_DASHBOARD, '/home'),
    // Batches of analyses started together from the New analysis panel.
    batches: path(ROOTS_DASHBOARD, '/batches'),
    batch: path(ROOTS_DASHBOARD, '/batches/:batchId'),
    kits: path(ROOTS_DASHBOARD, '/kits'),
    reports: path(ROOTS_DASHBOARD, '/reports'),
    search: path(ROOTS_DASHBOARD, '/search'),
    samples: path(ROOTS_DASHBOARD, '/samples'),
    variantDashboard: path(ROOTS_DASHBOARD, '/sample/:fileId/:sampleName'),
    variants: path(ROOTS_DASHBOARD, '/variants/:fileId/:sampleName?'),
    somaticVariants: path(ROOTS_DASHBOARD, '/somatic-variants/:analysisWrapperId'),
    variantDetails: path(ROOTS_DASHBOARD, '/variants/:fileId/:sampleName/:chrom/:pos'),
    admin: path(ROOTS_DASHBOARD, '/admin'),
    ebelge: path(ROOTS_DASHBOARD, '/ebelge'),
    unified: path(ROOTS_DASHBOARD, '/unified/:analysisWrapperId'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey'),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post'),
  },
  pipelines: path(ROOTS_DASHBOARD, '/pipeline-task-history/pipelines'),
}

// The somatic views of one analysis, as absolute links. Their routes are
// children of the dashboard root, so a bare `/somatic-structural/<id>` matches no
// route and the catch-all sends the reader home instead.
export const somaticVariantsPath = (analysisWrapperId) =>
  path(ROOTS_DASHBOARD, `/somatic-variants/${analysisWrapperId}`)
export const somaticStructuralPath = (analysisWrapperId) =>
  path(ROOTS_DASHBOARD, `/somatic-structural/${analysisWrapperId}`)
export const unifiedPath = (analysisWrapperId) => path(ROOTS_DASHBOARD, `/unified/${analysisWrapperId}`)
export const rnaAnalysisPath = (analysisWrapperId) => path(ROOTS_DASHBOARD, `/rna/${analysisWrapperId}`)
// The unified view opened on a region ("chr22:23180000-23320000").
export const unifiedRegionPath = (analysisWrapperId, region) =>
  `${unifiedPath(analysisWrapperId)}?region=${encodeURIComponent(region)}`
// The somatic variants of one analysis, filtered to one gene.
export const somaticVariantsGenePath = (analysisWrapperId, gene) =>
  `${somaticVariantsPath(analysisWrapperId)}?gene=${encodeURIComponent(gene)}`

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction'
